export const dashInvoices = {
  invoices: {
    title: "Fatture da inviare",
    subtitle: "Qui vedrai le richieste in attesa di emissione della fattura.",
    loading: "Caricamento…",
    empty: "Nessuna fattura da inviare.",
    guestFallback: "Ospite",
    manualBadge: "Manuale",
    manualBadgeTitle: "Non generata automaticamente: la emetti manualmente",
    manualCheckoutTitle: "Non generata automaticamente: emettila manualmente",
    linkSentTitle: "Link inviato all'ospite",
    linkPendingTitle: "Il link verrà inviato il giorno del check-out",
    manualIssue: "Emissione manuale",
    sendLinkTitle: "Invia all'ospite il link per completare i dati della fattura",
    resend: "Invia di nuovo",
    sendLink: "Invia link",
    closeRequestTitle: "Chiudi questa richiesta (la emetti manualmente)",
    close: "Chiudi",
    cancelAutoTitle: "Annulla l'invio automatico per inviarla manualmente con un altro mezzo",
    cancel: "Annulla",
    viewAll: "Vedi tutte le fatture",
    confirmCancel: {
      title: "Annullare l'invio automatico?",
      html: "Il link della fattura non verrà inviato all'ospite.<br>Potrai inviarlo manualmente con un altro mezzo.",
      confirm: "Sì, annulla",
      cancel: "No",
    },
    confirmSend: {
      title: "Inviare il link della fattura?",
      html: "Il link per completare i dati fiscali verrà inviato all'ospite via WhatsApp.<br>La fattura la emetti manualmente.",
      confirm: "Sì, invia",
      cancel: "No",
    },
    cancelError: {
      title: "Impossibile annullare",
    },
    closeError: {
      title: "Impossibile chiudere",
    },
    sendError: {
      title: "Impossibile inviare",
    },
    sendSuccess: {
      title: "Link inviato",
      text: "L'ospite ha ricevuto il link della fattura.",
    },
    retry: "Riprova.",
  },
  balances: {
    title: "Saldi in sospeso",
    subtitle: "Prenotazioni con un importo da saldare.",
    total: "Totale",
    paid: "Pagamento elaborato",
    loading: "Caricamento…",
    empty: "Nessun saldo in sospeso.",
    emptySub: "Quando una prenotazione ha un importo da saldare, comparirà qui.",
    viewAll: "Vedi tutti i saldi",
  },
  balancesDrawer: {
    title: "Saldi in sospeso",
    close: "Chiudi",
    from: "Da",
    to: "A",
    sort: "Ordina",
    sortArrival: "Data del check-in",
    sortProximity: "Prossimità dell'arrivo",
    searchPlaceholder: "Cerca alloggio…",
    allAccommodations: "Tutti gli alloggi",
    noResults: "Nessun risultato",
    clear: "Cancella",
    totalPending: "Totale in sospeso",
    ofTotal: "di {amount} {currency}",
    loading: "Caricamento…",
    empty: "Nessuna prenotazione con un saldo in sospeso.",
    end: "Nient'altro.",
    tags: {
      ended: "Soggiorno terminato",
      now: "In struttura",
      today: "Arriva oggi",
      tomorrow: "Arriva domani",
      dayAfter: "Arriva tra 2 giorni",
    },
  },
};
